// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 17:03:19

export default {
  "id": "block-up-1",
  "slug": "block-up-1",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/3b61e6b5bc68478092d4217139ccaf03-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/3b61e6b5bc68478092d4217139ccaf03/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Block Up",
      "description": "Block Up Contrast is a minimalist arcade game where you need a moving block upward through an endless series of obstacles. The challenge is to avoid barriers of contrasting colors while collecting points. The game requires precise timing and quick reflexes as the speed increases. With simple yet engaging gameplay, Block Up Contrast offers an addictive experience for players.  ",
      "instructions": "1. Tap to move the block upward.  \n2. Avoid obstacles of contrasting colors.  \n3. Time your taps carefully to navigate through gaps.  \n4. Collect points to increase your score.  \n5. React quickly as the speed increases over time.",
      "genres": [
        "Puzzle"
      ],
      "tags": [
        "block",
        "colorful",
        "tetris"
      ]
    },
    "zh-CN": {
      "title": "堵住",
      "description": "《块上对比》是一款简约的街机游戏，你需要将一个移动的方块向上通过无尽的障碍系列。挑战在于避开对比鲜明的颜色障碍物，同时收集得分。随着速度的提升，游戏需要精确的时间和快速的反射。凭借简单而又引人入胜的游戏玩法，《块上对比》为玩家提供了一种上瘾的游戏体验。",
      "instructions": "1. 点击移动方块向上。\n2. 避免不同颜色的障碍物。\n3. 精确地调整点击时间，穿过空隙。\n4. 收集分数以提高得分。\n5. 随着时间的推移，快速反应以适应加速。",
      "genres": [
        "谜题"
      ],
      "tags": [
        "方块",
        "多彩",
        "俄罗斯方块"
      ]
    },
    "zh-TW": {
      "title": "堵住",
      "description": "Block Up Contrast 是一款簡約街機遊戲，你需要將移動的塊向上通過無盡的障礙。挑戰是避免對比顏色的障礙物並收集分數。隨著速度增加，遊戲需要精確的時間掌握和快速的反應。Block Up Contrast 以簡單卻吸引人的遊戲性，為玩家提供上癮的體驗。",
      "instructions": "1. 轻觸向上移動方塊。\n2. 避開對比顏色的障礙物。\n3. 精準地計時觸控，穿過縫隙。\n4. 撿取分數以增加得分。\n5. 隨著時間增加速度，迅速反應。",
      "genres": [
        "謎題"
      ],
      "tags": [
        "阻塞",
        "色彩豐富",
        "俄羅斯方塊"
      ]
    },
    "zh-HK": {
      "title": "阻擋",
      "description": "Block Up Contrast 是一款極簡主義的電子遊戲，你需要操控一個移動的方塊向上通過無盡的障礙。挑戰是避開顏色對比的障礙物，同時收集分數。隨著速度的增加，遊戲需要精準的時間判斷和迅速的反應。以簡單而引人入勝的遊戲方式，Block Up Contrast 提供一種令人上癮的遊戲體驗。",
      "instructions": "1. 轻觸移動方塊向上。\n2. 避免顏色對比的障礙物。\n3. 輕觸時機要準確，穿梭過橫越的空隙。\n4. 準收分數以增加得分。\n5. 隨著時間增加速度，迅速作出反應。",
      "genres": [
        "謎題"
      ],
      "tags": [
        "阻塊",
        "colorful",
        "俄羅斯方塊"
      ]
    },
    "ja": {
      "title": "ブロックアップ",
      "description": "ブロックアップコントラストは、上下に動くブロックを無限に続く障害物の間を通すミニマリストのアーケードゲームです。挑戦は、ポイントを集めながら対照色のバリアを避けることです。ゲームは、速度が増えるにつれて正確なタイミングと速い反応が必要で、シンプルでありながら魅力的なゲームプレイを提供し、プレイヤーにとって中毒性のある体験を提供します。",
      "instructions": "1. ブロックを上に移動するにはタップしてください。\n2. 对比色の障害物を避けてください。\n3. ゴールを通るためにタップを慎重にタイミングしてください。\n4. ポイントを集め、スコアを上げましょう。\n5. 速度が時間とともに増えるので、素早く反応してください。",
      "genres": [
        "パズル"
      ],
      "tags": [
        "ブロック",
        "カラフル",
        "テトリス"
      ]
    },
    "ko": {
      "title": "블록업",
      "description": "블록업컨트라스트는 상상 속의 블록을 상승시키며 끝없는 장애물을 통과시켜야 하는 최소한의 아케이드 게임입니다. 도전은 대조적인 색상의 장애물을 피하면서 점수를 모으는 것입니다. 속도가 증가함에 따라 정확한 시간 조절과 빠른 반사 신경이 필요합니다. 간단하지만 재미있는 게임성으로 블록업컨트라스트는 플레이어에게 중독성 있는 경험을 제공합니다.",
      "instructions": "1. 블록을 위로 이동하려면 탭하세요.  \n2. 대조적인 색상의 장애물을 피하세요.  \n3. 구간을 통과하려면 탭하는 시간을 신중히 맞추세요.  \n4. 점수를 높이기 위해 점수를 모으세요.  \n5. 시간이 지남에 따라 속도가 증가하므로 빠르게 반응하세요.",
      "genres": [
        "퍼즐"
      ],
      "tags": [
        "블록",
        "다채로운",
        "테트리스"
      ]
    },
    "fr": {
      "title": "Bloquer",
      "description": "Block Up Contrast est un jeu d'arcade minimaliste où vous devez faire avancer un bloc vers le haut à travers une série infinie d'obstacles. Le défi consiste à éviter des barrières de couleurs contrastantes tout en collectant des points. Le jeu nécessite une précision dans le timing et des réflexes rapides au fur et à mesure que la vitesse augmente. Avec une jouabilité simple mais captivante, Block Up Contrast offre une expérience accrocheuse aux joueurs.",
      "instructions": "1. Tappez pour faire monter le bloc.\n2. Évitez les obstacles de couleurs contrastantes.\n3. Tempsz vos appuis pour traverser les espaces.\n4. Collectez des points pour augmenter votre score.\n5. Réagissez rapidement car la vitesse augmente au fil du temps.",
      "genres": [
        "Puzzle"
      ],
      "tags": [
        "bloc",
        "coloré",
        "tétris"
      ]
    }
  }
};
